export enum MyOrderActions {
	onInvoice,
	onLaterHere,
	onHereNow,
	onCancel
}
